<template>
    <json-ld v-if="data.name" :json="data" />
</template>
<script lang="ts" setup>
import { AggregateOffer } from 'schema-dts'
import JsonLd from '../JsonLd/JsonLd'
import { useGlobalStore } from '@sunrise/shared'
import { useInitializedAmsSearchStore } from '../../store/amsSearch'
import { computed } from 'vue'

const globalStore = useGlobalStore()
const amsStore = useInitializedAmsSearchStore()

const data = computed(() => {
    const prices = amsStore.results.items.map(({ price }) => price)

    return {
        '@context': 'https://schema.org',
        '@type': ['Vehicle', 'Product'],
        name: globalStore.requestContext?.pageMeta.title,
        offers: [
            {
                '@type': 'AggregateOffer',
                priceCurrency: 'EUR',
                offerCount: amsStore.results.totalHits,
                lowPrice: Math.min(...prices),
                highPrice: Math.max(...prices),
            } as AggregateOffer,
        ],
    }
})
</script>
